<template>
  <div>
    <breadcrumbs home="Cask type"/>

    <v-card flat >
      <v-form v-model="valid">
      <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-autocomplete v-model="type.spiritInId" outlined dense label="Starting spirit"
                              :items="spirits" item-text="name" item-value="id" persistent-hint
                              hint="The initial spirit put into a cask"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="6" sm="2">
              <decimal-number-input label="Maturation" v-model="age" prefix=""
                                    :suffix="period" :precision="period==='days'?0:1"/>
            </v-col>
            <v-col cols="3" sm="1">
              <v-switch v-model="period" label="Days" hide-details class="mt-1 ml-1" false-value="years" true-value="days" @change="setAge"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4">
              <v-autocomplete v-model="type.spiritOutId" outlined dense label="Spirit on maturation"
                              :items="spirits" item-text="name" item-value="id" persistent-hint
                              :hint="'The spirit produced after ' + age + ' ' + period"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-color-picker canvas-height="50" hide-inputs flat v-model="type.colour"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'InventoryCasksTypesEdit',
  mixins: [confirmLeave],
  props: {
    spiritInId: {type:String, required:false}
  },
  data () {
    return {
      spirits: [],
      type: {},
      age: 3,
      period: 'years',
      dirty: false,
      saving: false,
      loading: false,
      valid: true
    }
  },
  watch: {
    type: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    },
    age() {
      this.dirty = true;
    }
  },
  async created() {
    this.loading = true;
    await this.$lazyListLoad(this.spirits, 'spirits2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    const results = await this.$apiCall(`query InventoryCasksTypesEdit($edit:Boolean!,$spiritInId:ID!) {
                                            caskType(spiritInId:$spiritInId) @include(if:$edit) {
                                              spiritInId,spiritOutId,minimumAge,colour
                                            }
                                          }`,
                                        {edit:this.spiritInId!=undefined,spiritInId:this.spiritInId||''});
    if (!results.error) {
      if (this.spirits.length === 0) {
        this.$store.commit('setError', {message:'A cask type cannot be created without spirits defined',type:'error'})
        this.$nextTick(() => {
          this.dirty = false;
          this.$router.back();
        });
      }
      if (this.spiritInId) {
        this.type = results.data.caskType;
        this.age = this.type.minimumAge;
        this.setAge();
      }
      else if (this.spirits.length !== 0)
        this.type = {spiritInId: this.spirits[0].id, spiritOutId:this.spirits[0].id, colour:'#00ff00', minimumAge:1095};
    }
    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },

  methods: {
    setAge() {
      this.age = this.period === 'days' ? this.age * 365 : this.age / 365;
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.valid) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      const input = {...this.type, minimumAge:this.period === 'days' ? this.age : this.age * 365};
      const results = await this.$apiCall(`mutation InventoryCasksTypesEdit($input: CaskTypeInput!) {
                                             caskTypeCreate(input:$input) {spiritInId}
                                          }`, {input:input});
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.spiritInId?'Updated':'Created'} cask type`});
      }
    }
  }
}
</script>